"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const api_1 = require("./api");
const error_1 = require("./error");
const encoding_1 = require("./encoding");
class Client extends api_1.API {
    constructor(sender, crypto, getClientInfo) {
        super();
        this.sender = sender;
        this.crypto = crypto;
        this.getClientInfo = getClientInfo;
        for (const { method, output } of this.handlerDefinitions) {
            this[method] = (input) => {
                const promise = this.call(method, input ? [(0, encoding_1.serialize)(input)] : input).then((res) => {
                    return res.result && output
                        ? Array.isArray(res.result)
                            ? (0, encoding_1.deserializeArray)(output, res.result)
                            : (0, encoding_1.deserialize)(output, res.result)
                        : res.result;
                });
                return promise;
            };
        }
    }
    async call(method, params) {
        const req = { method, params, id: await this.crypto.uuid() };
        req.clientInfo = this.getClientInfo();
        if (this.session) {
            req.auth = { session: this.session.id, token: this.session.token };
        }
        let res;
        try {
            res = await this.sender.send(req);
        }
        catch (e) {
            this.errorHandler && this.errorHandler(e);
            throw e;
        }
        if (res.error) {
            const err = new error_1.Err(res.error.code, res.error.message);
            this.errorHandler && this.errorHandler(err);
            throw err;
        }
        //clears potential errors after a successful request
        this.errorHandler && this.errorHandler(null);
        return res;
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map